import { createFileRoute } from '@tanstack/react-router';

import DebugIndex from '~/debug/DebugIndex';

export const Route = createFileRoute('/debug/$')({
  component: DebugIndex,
});
